var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimIconLargeResubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 70,
    viewBox: "0 0 69 70",
    width: 69,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#f1f3f5",
    height: 70,
    rx: 4,
    width: 69
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 42c-1.65685425 0-3-1.3431458-3-3v-36c0-1.65685425 1.34314575-3 3-3h28c1.6568542 0 3 1.34314575 3 3v36c0 1.6568542-1.3431458 3-3 3zm4-34c-.55228475 0-1 .44771525-1 1s.44771525 1 1 1h8c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1zm0 16c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h17c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1zm0 4c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h20c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1zm0 4c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h15c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z",
    fill: "#868e96",
    transform: "translate(17 14)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 17,
    fill: "#495057",
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(44 11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.77777778 0 2.22222222 2-2.22222222 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5v-1c0-1.1045695.99492278-2 2.22222222-2h7.77777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.22222222 11-2.22222222-2 2.22222222-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 6v1c0 1.1045695-.99492278 2-2.22222222 2h-7.77777778"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimIconLargeResubmitted);
export default __webpack_public_path__ + "static/media/claim-icon-large-resubmitted.6dc07604b42b7d6368dc0a4e62a8b987.svg";
export { ForwardRef as ReactComponent };